module.exports = __webpack_public_path__ + "img/bgr-sparks.800ded64.svg";